import Vue from "vue";
import VueRouter from "vue-router";
import { ROUTER_MODE } from "../config/app";
import i18n from "../lang/index";
Vue.use(VueRouter);

const err401 = r =>
    require.ensure([], () => r(require("../views/error/err401.vue")), "home");
const err404 = r =>
    require.ensure([], () => r(require("../views/error/err404.vue")), "home");
const login = r =>
    require.ensure([], () => r(require("../views/login/index.vue")), "home");
const forgetPassword = r =>
    require.ensure(
        [],
        () => r(require("../views/login/forget-password.vue")),
        "home"
    );
// console.log(this.$store.state.admin.dataInfo.storeId);
// const res = this.$store.state.admin.dataInfo.storeId
//     ?
//     : "/store/store-statistics";
// 注意 权限字段 authRule （严格区分大小写）
export const constantRouterMap = [
    {
        path: "/401",
        component: err401,
        name: "401",
        hidden: true
    },
    {
        path: "/404",
        component: err404,
        name: "404",
        hidden: true
    },
    {
        path: "/500",
        component: err404,
        name: "500",
        hidden: true
    },
    {
        path: "/login",
        component: login,
        name: "登录",
        hidden: true
    },
    {
        path: "/forget-password",
        component: forgetPassword,
        name: "忘记密码",
        hidden: true
    },
    {
        path: "/",
        component: login,
        name: "登录",
        hidden: true
    }
];

// export default new VueRouter({
//     // mode: "history", //后端支持可开
//     mode: ROUTER_MODE,
//     routes: constantRouterMap,
//     strict: process.env.NODE_ENV !== "production"
// });

const createRouter = () =>
    new VueRouter({
        mode: ROUTER_MODE, // require service support
        routes: constantRouterMap,
        strict: process.env.NODE_ENV !== "production"
    });

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

export const asyncRouterMap = [
    {
        path: "/",
        component: resolve =>
            require(["../components/common/page.vue"], resolve),
        meta: {
            title: "整体页面布局"
        },
        children: [
            {
                path: "/home",
                component: resolve =>
                    require(["../views/home/index.vue"], resolve),
                meta: {
                    title: "首页"
                },
                name: "/home",
                redirect: "/home/main",
                children: [
                    {
                        path: "main",
                        name: "main",
                        component: resolve =>
                            require(["../views/home/main.vue"], resolve),
                        meta: {
                            title: "系统首页"
                        }
                    },
                    {
                        path: "stock",
                        name: "stock",
                        component: resolve =>
                            require([
                                "../views/home/project-stock.vue"
                            ], resolve),
                        meta: {
                            title: "项目库存"
                        }
                    },
                    {
                        path: "account-edit",
                        name: "account-edit",
                        component: resolve =>
                            require([
                                "../views/home/account-edit.vue"
                            ], resolve),
                        meta: {
                            title: "账户设置"
                        }
                    },
                    {
                        path: "system-info",
                        name: "system-info",
                        component: resolve =>
                            require(["../views/home/system-info.vue"], resolve),
                        meta: {
                            title: "系统信息"
                        }
                    },
                    {
                        path: "login-logs-list",
                        name: "login-logs-list",
                        component: resolve =>
                            require([
                                "../views/home/login-logs-list.vue"
                            ], resolve),
                        meta: {
                            title: "登录日志"
                        }
                    }
                ]
            },
            {
                path: "/project",
                name: "/project",
                component: resolve =>
                    require(["../views/project/index.vue"], resolve),
                meta: {
                    title: "排期"
                },
                redirect: "/project/list",
                children: [
                    {
                        path: "schedule",
                        name: "schedule",
                        component: resolve =>
                            require([
                                "../views/project/project-schedule.vue"
                            ], resolve),
                        meta: {
                            title: "项目排期"
                        }
                    },
                    {
                        path: "list",
                        name: "project-list",
                        component: resolve =>
                            require([
                                "../views/project/project-list.vue"
                            ], resolve),
                        meta: {
                            title: "项目列表"
                        }
                    },
                    {
                        path: "edit",
                        name: "project-edit",
                        component: resolve =>
                            require([
                                "../views/project/project-edit.vue"
                            ], resolve),
                        meta: {
                            title: "项目编辑"
                        }
                    },
                    {
                        path: "schedule-day-template",
                        name: "schedule-day-template",
                        component: resolve =>
                            require([
                                "../views/project/project-schedule-day-template.vue"
                            ], resolve),
                        meta: {
                            title: "模板管理"
                        }
                    },
                    {
                        path: "schedule-week-template",
                        name: "schedule-week-template",
                        component: resolve =>
                            require([
                                "../views/project/project-schedule-week-template.vue"
                            ], resolve),
                        meta: {
                            title: "周排期管理"
                        }
                    },
                    {
                        path: "day-schedule",
                        name: "day-schedule",
                        component: resolve =>
                            require([
                                "../views/project/project-day-schedule.vue"
                            ], resolve),
                        meta: {
                            title: "日排期管理"
                        }
                    }
                ]
            },
            {
                path: "/user",
                name: "/user",
                component: resolve =>
                    require(["../views/user/index.vue"], resolve),
                meta: {
                    title: i18n.t("router.t_user")
                },
                redirect: "/user/list",
                children: [
                    {
                        path: "list",
                        name: "user-list",
                        component: resolve =>
                            require(["../views/user/user-list.vue"], resolve),
                        meta: {
                            title: "用户列表"
                        }
                    },
                    {
                        path: "detail",
                        name: "user-detail",
                        component: resolve =>
                            require(["../views/user/user-detail.vue"], resolve),
                        meta: {
                            title: "用户详情"
                        }
                    },
                    {
                        path: "consumption-statistics",
                        name: "consumption-statistics",
                        component: resolve =>
                            require([
                                "../views/user/user-consumption-statistics.vue"
                            ], resolve),
                        meta: {
                            title: "购买力筛选"
                        }
                    },
                    {
                        path: "label-list",
                        name: "label-list",
                        component: resolve =>
                            require([
                                "../views/user/user-label-list.vue"
                            ], resolve),
                        meta: {
                            title: "会员标签管理"
                        }
                    },
                    {
                        path: "membercard-list",
                        name: "membercard-list",
                        component: resolve =>
                            require([
                                "../views/user/membercard-list.vue"
                            ], resolve),
                        meta: {
                            title: "会员卡"
                        }
                    }
                ]
            },
            {
                path: "/store",
                name: "/store",
                component: resolve =>
                    require(["../views/store/index.vue"], resolve),
                meta: {
                    title: "门店"
                },
                redirect: "/store/kart-parameters",
                children: [
                    {
                        path: "user-consumption-ranking-list",
                        name: "user-consumption-ranking-list",
                        component: resolve =>
                            require([
                                "../views/store/store-user-consumption-ranking-list.vue"
                            ], resolve),
                        meta: {
                            title: "会员消费排行"
                        }
                    },
                    {
                        path: "user-items-ranking-list",
                        name: "user-items-ranking-list",
                        component: resolve =>
                            require([
                                "../views/store/store-user-recharge-ranking-list.vue"
                            ], resolve),
                        meta: {
                            title: "会员充值排行"
                        }
                    },
                    {
                        path: "income-expenditure-list",
                        name: "income-expenditure-list",
                        component: resolve =>
                            require([
                                "../views/store/store-income-expenditure-list.vue"
                            ], resolve),
                        meta: {
                            title: "销售列表-项目合计"
                        }
                    },
                    {
                        path: "project-sale-statistics-list",
                        name: "project-sale-statistics-list",
                        component: resolve =>
                            require([
                                "../views/store/store-project-sale-statistics-list.vue"
                            ], resolve),
                        meta: {
                            title: "销售列表-项目合计"
                        }
                    },
                    {
                        path: "project-sale-profit-list",
                        name: "project-sale-profit-list",
                        component: resolve =>
                            require([
                                "../views/store/store-project-sale-statistics-list.vue"
                            ], resolve),
                        meta: {
                            title: "销售列表-参考收益(扣佣)"
                        }
                    },
                    {
                        path: "user-game-ranking-list",
                        name: "user-game-ranking-list",
                        component: resolve =>
                            require([
                                "../views/store/store-user-game-ranking-list.vue"
                            ], resolve),
                        meta: {
                            title: "会员参赛排行"
                        }
                    },
                    {
                        path: "staff-list",
                        name: "staff-list",
                        component: resolve =>
                            require([
                                "../views/store/store-staff-list.vue"
                            ], resolve),
                        meta: {
                            title: "人员列表"
                        }
                    },
                    {
                        path: "staff-edit",
                        name: "staff-edit",
                        component: resolve =>
                            require([
                                "../views/store/store-staff-edit.vue"
                            ], resolve),
                        meta: {
                            title: "人员编辑"
                        }
                    },
                    {
                        path: "machine-list",
                        name: "machine-list",
                        component: resolve =>
                            require([
                                "../views/store/store-machine-list.vue"
                            ], resolve),
                        meta: {
                            title: "设备列表"
                        }
                    },
                    {
                        path: "kart-parameters",
                        name: "kart-parameters",
                        component: resolve =>
                            require(["../views/store/store-kart.vue"], resolve),
                        meta: {
                            title: "卡丁车参数"
                        }
                    },
                    {
                        path: "machine-edit",
                        name: "machine-edit",
                        component: resolve =>
                            require([
                                "../views/store/store-machine-edit.vue"
                            ], resolve),
                        meta: {
                            title: "新增设备"
                        }
                    },
                    {
                        path: "store-statistics",
                        name: "store-statistics",
                        component: resolve =>
                            require([
                                "../views/store/store-statistics.vue"
                            ], resolve),
                        meta: {
                            title: "综合统计"
                        }
                    },
                    {
                        path: "store-statistics-list",
                        name: "store-statistics-list",
                        component: resolve =>
                            require([
                                "../views/store/store-statistics-list.vue"
                            ], resolve),
                        meta: {
                            title: "综合统计列表"
                        }
                    },
                    {
                        path: "store-deal",
                        name: "store-deal",
                        component: resolve =>
                            require(["../views/store/store-deal.vue"], resolve),
                        meta: {
                            title: "交易统计"
                        }
                    },
                    {
                        path: "store-sale-statistics",
                        name: "store-sale-statistics",
                        component: resolve =>
                            require([
                                "../views/store/store-sale-statistics.vue"
                            ], resolve),
                        meta: {
                            title: "销售统计"
                        }
                    },
                    {
                        path: "store-invite-statistics",
                        name: "store-invite-statistics",
                        component: resolve =>
                            require([
                                "../views/store/store-invite-statistics.vue"
                            ], resolve),
                        meta: {
                            title: "邀请统计"
                        }
                    },
                    {
                        path: "store-member-statistics",
                        name: "store-member-statistics",
                        component: resolve =>
                            require([
                                "../views/store/store-member-statistics.vue"
                            ], resolve),
                        meta: {
                            title: "会员统计"
                        }
                    }
                ]
            },
            {
                path: "/product",
                name: "/product",
                component: resolve =>
                    require(["../views/product/index.vue"], resolve),
                meta: {
                    title: i18n.t("router.t_product")
                },
                redirect: "/product/list",
                children: [
                    {
                        path: "list",
                        name: "product-list",
                        component: resolve =>
                            require([
                                "../views/product/product-list.vue"
                            ], resolve),
                        meta: {
                            title: "商品列表"
                        }
                    },
                    {
                        path: "edit",
                        name: "product-edit",
                        component: resolve =>
                            require([
                                "../views/product/product-edit.vue"
                            ], resolve),
                        meta: {
                            title: "新增商品"
                        }
                    },
                    {
                        path: "category",
                        name: "category",
                        component: resolve =>
                            require([
                                "../views/product/product-category-list.vue"
                            ], resolve),
                        meta: {
                            title: "商品分类"
                        }
                    },
                    {
                        path: "brand",
                        name: "brand",
                        component: resolve =>
                            require([
                                "../views/product/product-brand-list.vue"
                            ], resolve),
                        meta: {
                            title: "商品品牌"
                        }
                    },
                    {
                        path: "label",
                        name: "label",
                        component: resolve =>
                            require([
                                "../views/product/product-label.vue"
                            ], resolve),
                        meta: {
                            title: "商品标签"
                        }
                    },
                    {
                        path: "attribute",
                        name: "attribute",
                        component: resolve =>
                            require([
                                "../views/product/product-attribute.vue"
                            ], resolve),
                        meta: {
                            title: "商品属性"
                        }
                    },
                    {
                        path: "reward-give-list",
                        name: "reward-give-list",
                        component: resolve =>
                            require([
                                "../views/product/product-reward-give-list.vue"
                            ], resolve),
                        meta: {
                            title: "领取列表"
                        }
                    },
                    {
                        path: "reward-give-edit",
                        name: "reward-give-edit",
                        component: resolve =>
                            require([
                                "../views/product/product-reward-give-edit.vue"
                            ], resolve),
                        meta: {
                            title: "奖励领取"
                        }
                    },
                    {
                        path: "reward-list",
                        name: "reward-list",
                        component: resolve =>
                            require([
                                "../views/product/product-reward-list.vue"
                            ], resolve),
                        meta: {
                            title: "奖励列表"
                        }
                    },
                    {
                        path: "reward-edit",
                        name: "reward-edit",
                        component: resolve =>
                            require([
                                "../views/product/product-reward-edit.vue"
                            ], resolve),
                        meta: {
                            title: "奖励编辑"
                        }
                    },
                    {
                        path: "stock-in-list",
                        name: "stock-in-list",
                        component: resolve =>
                            require([
                                "../views/product/product-stock-in-list.vue"
                            ], resolve),
                        meta: {
                            title: "商品入库"
                        }
                    },
                    {
                        path: "stock-out-list",
                        name: "stock-out-list",
                        component: resolve =>
                            require([
                                "../views/product/product-stock-out-list.vue"
                            ], resolve),
                        meta: {
                            title: "商品出库"
                        }
                    }
                ]
            },
            {
                path: "/order",
                name: "/order",
                component: resolve =>
                    require(["../views/order/index.vue"], resolve),
                meta: {
                    title: i18n.t("router.t_order")
                },
                redirect: "/order/game-order-list/SINGLE_GAME",
                // redirect: "/order/consumption-list",
                children: [
                    {
                        path: "game-order-list/:type",
                        name: "game-order-list",
                        component: resolve =>
                            require([
                                "../views/order/single-game-order-list.vue"
                            ], resolve),
                        meta: {
                            title: "项目订单列表"
                        }
                    },
                    {
                        path: "product-order-list",
                        name: "product-order-list",
                        component: resolve =>
                            require([
                                "../views/order/product-order-list.vue"
                            ], resolve),
                        meta: {
                            title: "商品订单列表"
                        }
                    },
                    {
                        path: "recharges-order-list",
                        name: "recharges-order-list",
                        component: resolve =>
                            require([
                                "../views/order/recharges-order-list.vue"
                            ], resolve),
                        meta: {
                            title: "充值订单列表"
                        }
                    },
                    {
                        path: "game-order-detail",
                        name: "game-order-detail",
                        component: resolve =>
                            require([
                                "../views/order/single-game-order-detail.vue"
                            ], resolve),
                        meta: {
                            title: "项目订单详情"
                        }
                    },
                    {
                        path: "product-order-detail",
                        name: "product-order-detail",
                        component: resolve =>
                            require([
                                "../views/order/product-order-detail.vue"
                            ], resolve),
                        meta: {
                            title: "商品订单详情"
                        }
                    },
                    {
                        path: "single-game-order-create",
                        name: "single-game-order-create",
                        component: resolve =>
                            require([
                                "../views/order/single-game-order-create.vue"
                            ], resolve),
                        meta: {
                            title: "创建项目订单",
                            keepAlive: true
                        }
                    },
                    {
                        path: "single-game-order-create-schedule",
                        name: "single-game-order-create-schedule",
                        component: resolve =>
                            require([
                                "../views/order/single-game-order-create-schedule.vue"
                            ], resolve),
                        meta: {
                            title: "创建项目订单",
                            keepAlive: true
                        }
                    },
                    {
                        path: "private-game-order-create",
                        name: "private-game-order-create",
                        component: resolve =>
                            require([
                                "../views/order/private-game-order-create.vue"
                            ], resolve),
                        meta: {
                            title: "创建包场订单",
                            keepAlive: true
                        }
                    },
                    {
                        path: "product-order-create",
                        name: "product-order-create",
                        component: resolve =>
                            require([
                                "../views/order/product-order-create.vue"
                            ], resolve),
                        meta: {
                            title: "创建商品订单",
                            keepAlive: true
                        }
                    },
                    {
                        path: "single-game-order-list",
                        name: "single-game-order-list",
                        component: resolve =>
                            require([
                                "../views/order/single-game-order-list.vue"
                            ], resolve),
                        meta: {
                            title: "订单列表"
                        }
                    },
                    {
                        path: "create",
                        name: "create",
                        component: resolve =>
                            require([
                                "../views/product/product-create.vue"
                            ], resolve),
                        meta: {
                            title: "新增商品"
                        }
                    },
                    {
                        path: "reward-give-list",
                        name: "reward-give-list",
                        component: resolve =>
                            require([
                                "../views/product/product-reward-give-list.vue"
                            ], resolve),
                        meta: {
                            title: "领取列表"
                        }
                    },
                    {
                        path: "reward-list",
                        name: "reward-list",
                        component: resolve =>
                            require([
                                "../views/product/product-reward-list.vue"
                            ], resolve),
                        meta: {
                            title: "奖励列表"
                        }
                    },
                    {
                        path: "stock-in-list",
                        name: "stock-in-list",
                        component: resolve =>
                            require([
                                "../views/product/product-stock-in-list.vue"
                            ], resolve),
                        meta: {
                            title: "商品入库"
                        }
                    },
                    {
                        path: "refund-list",
                        name: "refund-list",
                        component: resolve =>
                            require([
                                "../views/order/order-refund-list.vue"
                            ], resolve),
                        meta: {
                            title: "退款申请列表"
                        }
                    },
                    {
                        path: "refund-detail",
                        name: "refund-detail",
                        component: resolve =>
                            require([
                                "../views/order/order-refund-detail.vue"
                            ], resolve),
                        meta: {
                            title: "退款申请详情"
                        }
                    },
                    {
                        path: "consumption-list",
                        name: "consumption-list",
                        component: resolve =>
                            require([
                                "../views/order/order-consumption-list.vue"
                            ], resolve),
                        meta: {
                            title: "场次核销"
                        }
                    }
                ]
            },
            {
                path: "/operation",
                name: "/operation",
                component: resolve =>
                    require(["../views/operation/index.vue"], resolve),
                meta: {
                    title: "运营"
                },
                redirect: "/operation/activity-list",
                children: [
                    {
                        path: "coupon-list",
                        name: "coupon-list",
                        component: resolve =>
                            require([
                                "../views/operation/coupon-list.vue"
                            ], resolve),
                        meta: {
                            title: "优惠券列表"
                        }
                    },
                    {
                        path: "coupon-edit",
                        name: "coupon-edit",
                        component: resolve =>
                            require([
                                "../views/operation/coupon-edit.vue"
                            ], resolve),
                        meta: {
                            title: "优惠券编辑"
                        }
                    },
                    {
                        path: "coupon-consume-list",
                        name: "coupon-consume-list",
                        component: resolve =>
                            require([
                                "../views/operation/coupon-consume-list.vue"
                            ], resolve),
                        meta: {
                            title: "优惠券使用查询"
                        }
                    },
                    {
                        path: "coupon-detail",
                        name: "coupon-detail",
                        component: resolve =>
                            require([
                                "../views/operation/coupon-detail.vue"
                            ], resolve),
                        meta: {
                            title: "优惠券明细"
                        }
                    },
                    {
                        path: "activity-list",
                        name: "activity-list",
                        component: resolve =>
                            require([
                                "../views/operation/activity-list.vue"
                            ], resolve),
                        meta: {
                            title: "活动列表"
                        }
                    },
                    {
                        path: "activity-edit",
                        name: "activity-edit",
                        component: resolve =>
                            require([
                                "../views/operation/activity-edit.vue"
                            ], resolve),
                        meta: {
                            title: "活动编辑"
                        }
                    },
                    {
                        path: "guide-list",
                        name: "guide-list",
                        component: resolve =>
                            require([
                                "../views/operation/guide-list.vue"
                            ], resolve),
                        meta: {
                            title: "指引列表"
                        }
                    },
                    {
                        path: "guide-edit",
                        name: "guide-edit",
                        component: resolve =>
                            require([
                                "../views/operation/guide-edit.vue"
                            ], resolve),
                        meta: {
                            title: "指引编辑"
                        }
                    },
                    {
                        path: "/operation/evaluate-list",
                        name: "evaluate-list",
                        component: resolve =>
                            require([
                                "../views/operation/evaluate-list.vue"
                            ], resolve),
                        meta: {
                            title: "评价管理"
                        }
                    },
                    {
                        path: "/operation/evaluate-detail",
                        name: "/operation/evaluate-detail",
                        component: resolve =>
                            require([
                                "../views/operation/evaluate-detail.vue"
                            ], resolve),
                        meta: {
                            title: "评价详情"
                        }
                    },
                    {
                        path: "employee-invite",
                        name: "employee-invite",
                        component: resolve =>
                            require([
                                "../views/operation/employee-invite.vue"
                            ], resolve),
                        meta: {
                            title: "员工邀请码列表"
                        }
                    },
                    {
                        path: "invite-code-edit",
                        name: "invite-code-edit",
                        component: resolve =>
                            require([
                                "../views/operation/invite-code-edit.vue"
                            ], resolve),
                        meta: {
                            title: "新增邀请码"
                        }
                    },
                    {
                        path: "staff-invite-code-list",
                        name: "staff-invite-code-list",
                        component: resolve =>
                            require([
                                "../views/operation/staff-invite-code-list.vue"
                            ], resolve),
                        meta: {
                            title: "邀请码列表"
                        }
                    },
                    {
                        path: "invite-code-consume-list",
                        name: "invite-code-consume-list",
                        component: resolve =>
                            require([
                                "../views/operation/invite-code-consume-list.vue"
                            ], resolve),
                        meta: {
                            title: "邀请码使用查询"
                        }
                    },
                    {
                        path: "invite-code-detail",
                        name: "invite-code-detail",
                        component: resolve =>
                            require([
                                "../views/operation/invite-code-detail.vue"
                            ], resolve),
                        meta: {
                            title: "邀请码明细"
                        }
                    }
                ]
            },
            {
                path: "/system",
                name: "/system",
                component: resolve =>
                    require(["../views/system/index.vue"], resolve),
                meta: {
                    title: "设置"
                },
                redirect: "/system/notification-list",
                children: [
                    {
                        path: "store-list",
                        name: "store-list",
                        component: resolve =>
                            require([
                                "../views/system/store-list.vue"
                            ], resolve),
                        meta: {
                            title: "门店管理"
                        }
                    },
                    {
                        path: "store-edit",
                        name: "store-edit",
                        component: resolve =>
                            require([
                                "../views/system/store-edit.vue"
                            ], resolve),
                        meta: {
                            title: "门店编辑"
                        }
                    },
                    {
                        path: "store-staff-list",
                        name: "store-staff-list",
                        component: resolve =>
                            require([
                                "../views/system/store-staff-list.vue"
                            ], resolve),
                        meta: {
                            title: "成员管理"
                        }
                    },
                    {
                        path: "store-staff-edit",
                        name: "store-staff-edit",
                        component: resolve =>
                            require([
                                "../views/system/store-staff-edit.vue"
                            ], resolve),
                        meta: {
                            title: "成员编辑"
                        }
                    },
                    {
                        path: "notification-list",
                        name: "notification-list",
                        component: resolve =>
                            require([
                                "../views/system/NotificationList.vue"
                            ], resolve),
                        meta: {
                            title: "系统消息"
                        }
                    },
                    {
                        path: "role-list",
                        name: "role-list",
                        component: resolve =>
                            require(["../views/system/role-list.vue"], resolve),
                        meta: {
                            title: "角色管理"
                        }
                    },
                    {
                        path: "role-edit",
                        name: "role-edit",
                        component: resolve =>
                            require(["../views/system/role-edit.vue"], resolve),
                        meta: {
                            title: "角色编辑"
                        }
                    },
                    {
                        path: "authority-edit",
                        name: "authority-edit",
                        component: resolve =>
                            require([
                                "../views/system/authority-edit.vue"
                            ], resolve),
                        meta: {
                            title: "权限设置"
                        }
                    },
                    // {
                    //     path: "log-list",
                    //     name: "log-list",
                    //     component: resolve =>
                    //         require(["../views/system/log-list.vue"], resolve),
                    //     meta: {
                    //         title: "操作日志"
                    //     }
                    // },
                    {
                        path: "product-brand-list",
                        name: "product-brand-list",
                        component: resolve =>
                            require([
                                "../views/product/product-brand-list.vue"
                            ], resolve),
                        meta: {
                            title: "商品品牌管理"
                        }
                    },
                    {
                        path: "product-attribute-list",
                        name: "product-attribute-list",
                        component: resolve =>
                            require([
                                "../views/product/dictionary-product-attribute-list.vue"
                            ], resolve),
                        meta: {
                            title: "商品属性管理"
                        }
                    },
                    {
                        path: "product-category-list",
                        name: "product-category-list",
                        component: resolve =>
                            require([
                                "../views/product/product-category-list.vue"
                            ], resolve),
                        meta: {
                            title: "商品分类管理"
                        }
                    },
                    {
                        path: "product-label-list",
                        name: "product-label-list",
                        component: resolve =>
                            require([
                                "../views/product/dictionary-product-label-list.vue"
                            ], resolve),
                        meta: {
                            title: "商品标签管理"
                        }
                    },
                    {
                        path: "machine-parameter-list",
                        name: "machine-parameter-list",
                        component: resolve =>
                            require([
                                "../views/system/dictionary-machine-parameter-list.vue"
                            ], resolve),
                        meta: {
                            title: "卡丁车技术参数管理"
                        }
                    },
                    {
                        path: "income-item-list",
                        name: "income-item-list",
                        component: resolve =>
                            require([
                                "../views/system/dictionary-income-item-list.vue"
                            ], resolve),
                        meta: {
                            title: "收支项目设置"
                        }
                    },
                    {
                        path: "expend-item-list",
                        name: "expend-item-list",
                        component: resolve =>
                            require([
                                "../views/system/dictionary-expend-item-list.vue"
                            ], resolve),
                        meta: {
                            title: "支出项目管理"
                        }
                    },
                    {
                        path: "promotions-edit",
                        name: "promotions-edit",
                        component: resolve =>
                            require([
                                "../views/system/promotions-edit.vue"
                            ], resolve),
                        meta: {
                            title: "优惠设置"
                        }
                    },
                    {
                        path: "platform-info-edit",
                        name: "platform-info-edit",
                        component: resolve =>
                            require([
                                "../views/system/platform-info-edit.vue"
                            ], resolve),
                        meta: {
                            title: "平台信息设置"
                        }
                    },
                    {
                        path: "agreement-edit",
                        name: "agreement-edit",
                        component: resolve =>
                            require([
                                "../views/system/agreement-edit.vue"
                            ], resolve),
                        meta: {
                            title: "用户协议设置"
                        }
                    },
                    {
                        path: "upgradeReward-edit",
                        name: "upgradeReward-edit",
                        component: resolve =>
                            require([
                                "../views/system/upgradeReward-edit.vue"
                            ], resolve),
                        meta: {
                            title: "升级奖励"
                        }
                    },
                    {
                        path: "otherInfo-edit-edit",
                        name: "otherInfo-edit-edit",
                        component: resolve =>
                            require([
                                "../views/system/otherInfo-edit.vue"
                            ], resolve),
                        meta: {
                            title: "其他信息设置"
                        }
                    },
                    {
                        path: "level-list",
                        name: "level-list",
                        component: resolve =>
                            require([
                                "../views/system/user-level-list.vue"
                            ], resolve),
                        meta: {
                            title: "会员等级管理"
                        }
                    },
                    {
                        path: "service-edit",
                        name: "service-edit",
                        component: resolve =>
                            require([
                                "../views/system/service-edit.vue"
                            ], resolve),
                        meta: {
                            title: "退改签说明设置"
                        }
                    },
                    {
                        path: "information-edit",
                        name: "information-edit",
                        component: resolve =>
                            require([
                                "../views/system/information-edit.vue"
                            ], resolve),
                        meta: {
                            title: "购票须知"
                        }
                    },
                    {
                        path: "payment-list",
                        name: "payment-list",
                        component: resolve =>
                            require([
                                "../views/system/payment-list.vue"
                            ], resolve),
                        meta: {
                            title: "支付设置"
                        }
                    },
                    {
                        path: "payment-edit",
                        name: "payment-edit",
                        component: resolve =>
                            require([
                                "../views/system/payment-edit.vue"
                            ], resolve),
                        meta: {
                            title: "支付编辑"
                        }
                    },
                    {
                        path: "recharge-list",
                        name: "recharge-list",
                        component: resolve =>
                            require([
                                "../views/system/recharge-list.vue"
                            ], resolve),
                        meta: {
                            title: "充值设置"
                        }
                    },
                    {
                        path: "recharge-edit",
                        name: "recharge-edit",
                        component: resolve =>
                            require([
                                "../views/system/recharge-edit.vue"
                            ], resolve),
                        meta: {
                            title: "充值编辑"
                        }
                    },
                    {
                        path: "cashier-payment",
                        name: "cashier-payment",
                        component: resolve =>
                            require([
                                "../views/system/cashier-payment.vue"
                            ], resolve),
                        meta: {
                            title: "收银支付"
                        }
                    },
                    {
                        path: "cashier-printer",
                        name: "cashier-printer",
                        component: resolve =>
                            require([
                                "../views/system/cashier-printer.vue"
                            ], resolve),
                        meta: {
                            title: "收银打印机管理"
                        }
                    },
                    {
                        path: "sale-rule",
                        name: "sale-rule",
                        component: resolve =>
                            require([
                                "../views/system/order-sale-rule.vue"
                            ], resolve),
                        meta: {
                            title: "订单设置"
                        }
                    },
                    {
                        path: "print-rule",
                        name: "print-rule",
                        component: resolve =>
                            require([
                                "../views/system/order-print-rule.vue"
                            ], resolve),
                        meta: {
                            title: "订单小票设置"
                        }
                    },
                    {
                        path: "order-refund-rule",
                        name: "order-refund-rule",
                        component: resolve =>
                            require([
                                "../views/system/order-refund-rule.vue"
                            ], resolve),
                        meta: {
                            title: "退款设置"
                        }
                    },
                    {
                        path: "refund-rate-rule",
                        name: "refund-rate-rule",
                        component: resolve =>
                            require([
                                "../views/system/order-refund-rate-rule.vue"
                            ], resolve),
                        meta: {
                            title: "退款费率设置"
                        }
                    },
                    {
                        path: "reward-list",
                        name: "reward-list",
                        component: resolve =>
                            require([
                                "../views/system/reward-list.vue"
                            ], resolve),
                        meta: {
                            title: "奖励设置"
                        }
                    },
                    {
                        path: "experience-list",
                        name: "experience-list",
                        component: resolve =>
                            require([
                                "../views/system/experience-list.vue"
                            ], resolve),
                        meta: {
                            title: "经验值设置"
                        }
                    },
                    {
                        path: "membersLevel-list",
                        name: "membersLevel-list",
                        component: resolve =>
                            require([
                                "../views/system/membersLevel-list.vue"
                            ], resolve),
                        meta: {
                            title: "会员卡级别"
                        }
                    },
                    {
                        path: "invite-channel-list",
                        name: "invite-channel-list",
                        component: resolve =>
                            require([
                                "../views/system/invite-channel-list.vue"
                            ], resolve),
                        meta: {
                            title: "邀请码渠道"
                        }
                    },
                    {
                        path: "notification-rule",
                        name: "notification-rule",
                        component: resolve =>
                            require([
                                "../views/system/notification-rule.vue"
                            ], resolve),
                        meta: {
                            title: "消息提醒设置"
                        }
                    },

                    {
                        path: "otherInfo-edit",
                        name: "otherInfo-edit",
                        component: resolve =>
                            require([
                                "../views/system/otherInfo-edit.vue"
                            ], resolve),
                        meta: {
                            title: "其他消息设置"
                        }
                    }
                ]
            }
        ]
    }
];

export default router;
